import {
  GraduationCap, Landmark, Contrast, ShieldCheck,
  KeyRound, Users, Database, Lock,
} from "lucide-react";
import "./ccCompliance.css";

/* The IT review in one section: the four standards RAIN clears on the top
   row, the four controls it ships on the bottom. Eight chips, four up.

   Each entry can carry a `badge` — the certification mark itself (FERPA,
   WCAG, CASA), the way the Asana reference does it. Import the image and set
   `badge: theImage`; the lucide `icon` is the stand-in until the art lands,
   and stays the mark for the four rows that have no logo to show.

   WCAG is marked with a contrast disc rather than the wheelchair glyph:
   these are standards RAIN clears, and the wheelchair reads as a claim about
   who the product is for instead. Contrast is the WCAG criterion everyone
   recognises, and it sits beside the other four abstract marks.

   Two of the standards need to be true before this page ships:
   - WCAG 2.1 AA — the accessibility page states this as an aim ("we aim to
     conform"), which is not the same as an audited VPAT. Run the audit.
   - CASA Tier 2 — likely already held through the Gmail scope review, but
     confirm the assessment is current before publishing it.

   "US state privacy laws" names no law, which is the one chip an IT
   reviewer cannot check — kept anyway, on Jacob's call, to hold the row at
   eight. Naming the two or three that actually apply would make it the
   strongest chip here rather than the softest.

   SOC 2 Type II belongs on this row the day the report exists — nothing in
   this repo says it does, so it is not listed. Add it with the audit date
   in hand, not before.

   The bottom row is all shipping today, because the point of the block is
   that it survives the follow-up question. Note the deliberate wording on
   data isolation: it is per-institution, not per-user. */
const standards = [
  { icon: GraduationCap, label: "FERPA compliant" },
  { icon: Landmark, label: "US state privacy laws" },
  { icon: Contrast, label: "WCAG 2.1 Level AA" },
  { icon: ShieldCheck, label: "CASA Tier 2 certified" },
  { icon: KeyRound, label: "Campus SSO (SAML)" },
  { icon: Users, label: "Role-based access control" },
  { icon: Database, label: "Per-institution data isolation" },
  { icon: Lock, label: "US data residency and encryption" },
];

const CcCompliance = () => (
  <section className="cc-section cc-compliance">
    <div className="home-container">
      <div className="cc-comp-head">
        <h2 className="cc-comp-title">
          We meet the standards
          <br />
          your IT team asks for
        </h2>

        <p className="cc-lead cc-comp-sub">
          RAIN meets the same compliance obligations your campus does, so the
          review is quick, not a project.
        </p>
      </div>

      <ul className="cc-comp-grid">
        {standards.map(({ icon: Icon, badge, label }) => (
          <li className="cc-comp-item" key={label}>
            <span className="cc-comp-icon">
              {badge ? (
                <img decoding="async" className="cc-comp-badge" src={badge} alt="" />
              ) : (
                <Icon size={26} strokeWidth={1.6} />
              )}
            </span>
            <span className="cc-comp-label">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CcCompliance;
